var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.4789 8.34407C11.4789 8.96075 11.296 9.56359 10.9534 10.0763C10.6108 10.5891 10.1239 10.9887 9.55412 11.2247C8.98438 11.4607 8.35746 11.5225 7.75262 11.4022C7.14779 11.2819 6.59222 10.9849 6.15616 10.5488C5.7201 10.1128 5.42314 9.55719 5.30283 8.95236C5.18252 8.34753 5.24427 7.7206 5.48026 7.15086C5.71626 6.58112 6.11589 6.09415 6.62865 5.75154C7.1414 5.40893 7.74423 5.22607 8.36092 5.22607C9.18786 5.22607 9.98094 5.55457 10.5657 6.13931C11.1504 6.72405 11.4789 7.51713 11.4789 8.34407Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.17 16.1699H8.33496",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36101 11.4789H13.091C14.515 11.4789 16.17 10.402 16.17 7.60496C16.17 3.27796 12.586 0.458949 8.259 0.504949C7.23016 0.509874 6.21236 0.717397 5.26372 1.11567C4.31508 1.51394 3.45418 2.09516 2.73016 2.82615C2.00614 3.55713 1.43319 4.42356 1.04402 5.37597C0.654849 6.32838 0.457079 7.34812 0.462004 8.37696C0.466928 9.4058 0.674451 10.4236 1.07272 11.3722C1.47099 12.3209 2.05221 13.1818 2.78319 13.9058C3.51418 14.6298 4.3806 15.2028 5.33301 15.5919C6.28542 15.9811 7.30516 16.1789 8.33401 16.174",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c162b96c7162f63c0f3dfa307493d60b.svg";
export { ForwardRef as ReactComponent };